import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import { DEFAULT_ALLOWED_FILE_EXTENSIONS, AppDashboardOptions, DefaultMeta, DefaultBody, AppUppy } from "common";

export const MAX_UPLOAD_FILES_COUNT = 10;

export const getUppyInstance = (
  endpoint: string,
  accessToken: string,
  maxNumberOfFiles: number
): AppUppy => {
  const uppy = new Uppy<DefaultMeta, DefaultBody>({
    debug: false,
    autoProceed: false,
    restrictions: {
      maxFileSize: 20971520, // 20MB
      maxNumberOfFiles,
      allowedFileTypes: DEFAULT_ALLOWED_FILE_EXTENSIONS,
    },
  });

  uppy.use(XHRUpload, {
    endpoint: (fileOrBundle) => {
      if (!Array.isArray(fileOrBundle)) {
        const fileMeta = fileOrBundle.meta;
        return (fileMeta as Record<string, unknown>).uploadEndpoint as string || endpoint;
      }
      return endpoint;
    },
    headers: (file) => {
      const fileMeta = file.meta;
      const token = (fileMeta as Record<string, unknown>).uploadAuthToken as string;
      return {
        Authorization: `Bearer ${token || accessToken}`,
      };
    },
  });

  return uppy;
};

export const updateUppyEndpoint = (uppy: AppUppy, endpoint: string): void => {
  if (!!uppy) {
    uppy.getPlugin("XHRUpload").setOptions({ endpoint });
  }
};

export const getUppyDashboardOptions = (): AppDashboardOptions => {
  return {
    id: "Dashboard",
    height: 312,
    width: 480,
    plugins: [],
    hideUploadButton: true,
    hideRetryButton: true,
    hidePauseResumeButton: true,
    proudlyDisplayPoweredByUppy: false,
  };
};
